export default function Tab1() {
  return <div> One day </div>;
}
